import 'i18next';
import { IsNotEmpty, IsOptional, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class ConfigureHumanTestingDto {
  @IsNotEmpty({
    message: t('prototypes:validation.final_trigger_element_cannot_be_empty'),
  })
  finalTriggerElement = '';

  @IsOptional()
  @MinLength(1, {
    message: t('prototypes:validation.final_question_too_short', {
      minLength: 1,
    }),
  })
  @MaxLength(2500, {
    message: t('prototypes:validation.final_question_too_long', {
      maxLength: 2500,
    }),
  })
  finalQuestion = '';
}
